import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, UsersIcon, AwardIcon } from 'lucide-react';
export const SocialProof = () => {
  const testimonials = [{
    name: 'Carlos Mendoza',
    role: 'Emprendedor Digital',
    text: 'Implementé el método de Sharon y logré crear mi primer producto digital en menos de una semana. Ya he generado mis primeras ventas sin tener que mostrar mi cara.',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    name: 'Marta Jiménez',
    role: 'Coach de Negocios',
    text: 'La clase de Sharon transformó mi negocio. Aprendí a utilizar IA para crear contenido de calidad y ahora vendo mis cursos mientras duermo.',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    name: 'Eduardo Rivas',
    role: 'Diseñador Gráfico',
    text: 'Nunca pensé que podría crear un producto digital tan rápido. Gracias a las técnicas de Sharon, ahora tengo una fuente de ingresos pasivos que crece cada mes.',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }];
  const companies = ['https://cdn-icons-png.flaticon.com/512/5968/5968764.png', 'https://cdn-icons-png.flaticon.com/512/5968/5968534.png', 'https://cdn-icons-png.flaticon.com/512/5968/5968919.png', 'https://cdn-icons-png.flaticon.com/512/5968/5968866.png', 'https://cdn-icons-png.flaticon.com/512/5968/5968872.png' // Zapier
  ];
  const stats = [{
    value: '1000+',
    label: 'Estudiantes Satisfechos'
  }, {
    value: '92%',
    label: 'Tasa de Éxito'
  }, {
    value: '100%',
    label: 'Garantía de Satisfacción'
  }];
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0
    }
  };
  return <section className="py-12 px-4 relative" data-id="element-172">
      <div className="container mx-auto max-w-6xl" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-174">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400" data-id="element-175">
            Resultados comprobados
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto" data-id="element-176">
            Descubre por qué cientos de emprendedores confían en nuestro método
            para crear y vender productos digitales con éxito
          </p>
        </motion.div>
        {/* Estadísticas */}
        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
        once: true
      }} className="grid grid-cols-2 md:grid-cols-3 gap-6 mb-12" data-id="element-177">
          {stats.map((stat, index) => <motion.div key={index} variants={item} className="bg-gradient-to-r from-blue-900/20 to-purple-900/20 p-6 rounded-xl border border-gray-800 text-center" data-id="element-178">
              <div className="text-3xl md:text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400 mb-2" data-id="element-179">
                {stat.value}
              </div>
              <div className="text-gray-400" data-id="element-180">{stat.label}</div>
            </motion.div>)}
        </motion.div>
        {/* Testimonios */}
        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
        once: true
      }} className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-181">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={item} className="bg-gray-900/50 backdrop-blur-sm p-6 rounded-xl border border-gray-800 relative" data-id="element-182">
              <div className="flex items-center gap-1 text-yellow-400 mb-4" data-id="element-183">
                {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} fill="currentColor" data-id="element-184" />)}
              </div>
              <p className="text-gray-300 mb-6" data-id="element-185">"{testimonial.text}"</p>
              <div className="flex items-center gap-3" data-id="element-186">
                <img src={testimonial.avatar} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover" data-id="element-187" />
                <div data-id="element-188">
                  <div className="font-medium" data-id="element-189">{testimonial.name}</div>
                  <div className="text-sm text-gray-400" data-id="element-190">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
        {/* Logos */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true
      }} className="py-10" data-id="element-191">
          <p className="text-center text-gray-500 mb-8 text-sm uppercase tracking-wider" data-id="element-192">
            Herramientas recomendadas por nuestros expertos
          </p>
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16" data-id="element-193">
            {companies.map((logo, index) => <img key={index} src={logo} alt="Company logo" className="h-8 md:h-10 opacity-50 grayscale hover:opacity-70 hover:grayscale-0 transition-all duration-300" data-id="element-194" />)}
          </div>
        </motion.div>
        {/* CTA Final */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} viewport={{
        once: true
      }} className="mt-12 text-center" data-id="element-195">
          <div className="inline-block px-4 py-1 mb-6 rounded-full bg-gradient-to-r from-blue-600/30 to-purple-600/30 border border-purple-500/30 text-sm" data-id="element-196">
            <span className="flex items-center gap-1" data-id="element-197">
              <UsersIcon size={14} className="text-purple-400" data-id="element-198" />
              <span className="text-gray-300" data-id="element-199">
                Plazas limitadas - Solo 100 asistentes
              </span>
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400" data-id="element-200">
            Quiero estar en la clase
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto mb-8" data-id="element-201">
            No pierdas esta oportunidad única de aprender a crear y vender tu
            propio producto digital usando IA. Las plazas son limitadas y se
            llenarán rápidamente.
          </p>
          <motion.a href="#top" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block px-8 py-4 rounded-lg bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 text-white font-bold text-lg relative overflow-hidden group" data-id="element-202">
            <span className="relative z-10 flex items-center gap-2" data-id="element-203">
              <AwardIcon size={20} data-id="element-204" />
              Reservar mi plaza ahora
            </span>
            <span className="absolute inset-0 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-205"></span>
          </motion.a>
          <p className="text-sm text-gray-400 mt-4" data-id="element-206">
            Clase gratuita con cupos limitados - 21 de marzo, 10:00 AM (hora de
            Miami)
          </p>
        </motion.div>
      </div>
    </section>;
};